// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    add: 'Agregar',
    AddMoreSpace: 'Actualice ahora',
    all_projects_label: 'Todos los proyectos',
    archive_action_text: 'Archivo',
    Attach: 'Adjuntar archivo',
    attach_file_image: 'Adjuntar archivo o imagen',
    btn_reload: 'Cargar',
    Cancel: 'Cancelar',
    change: 'Cambiar',
    Close: 'Cerrar',
    completeActivityConfirm: 'Ha especificado que esta actividad está 100% completa. Quieres completar la actividad? Presione \'OK\' para cambiar el estado, o\' Cancelar \' en caso contrario.',
    completeActivityTitle: 'Quieres completar esta actividad?',
    completeProjectConfirm: 'Ha especificado que este proyecto está 100% completo. Quieres completar este proyecto? Presione \'OK\' para cambiar el estado.',
    completeProjectTitle: 'Quieres completar este proyecto?',
    confirmCompleteActivityParents: 'Completar esta actividad no dejará actividades sin completar en este proyecto (actividad principal). Le gustaría completar el proyecto o la actividad de los padres, lo que sea apropiado, también?',
    confirmCompleteActivityParentsTitle: 'Establecer el estado de {0}como completado?',
    continue: 'Continuar',
    copyLink: 'Copiar Link',
    DayAbbreviation: 'd',
    DayPluralFormat: '1#día#dias',
    DayPluralFormatTemplate: '1#{0} día#{0} dias',
    Delete: 'Eliminar',
    delete_confirmation: 'Esta acción no se puede deshacer.',
    delete_permanently_text: 'Eliminar Permanente',
    disabled: 'Deshabilitado',
    disabledUserText: '(deshabilitado)',
    Download: 'Descargar',
    Duplicate: 'Duplicar',
    Edit: 'Editar',
    ElapsedTime_Ago: '{0} hace',
    enabled: 'Habilitado',
    Entity_Category: 'Categoría',
    Entity_Customer: 'Cliente',
    Entity_Issue: 'Asunto',
    Entity_Portfolio: 'Portafolio',
    Entity_Priority: 'Prioridad',
    Entity_Project: 'Proyecto',
    Entity_ProjectStatus: 'Estado',
    Entity_Request: 'Solicitud',
    Entity_Task: 'Tarea',
    Entity_TaskStatus: 'Estado',
    Entity_User: 'Usuario',
    Error_CantFindObjectTemplate: 'La operación no se pudo completar por los siguientes motivos: elemento (tipo: {entityName}, ID:{objectKey}) no encontrado en la base de datos.  Esto puede deberse a la eliminación o a la falta de permiso para ver el elemento. Consulte con su {brandName} administrador para conocer las posibles causas.',
    error_notFullyCompleted: 'Un objeto o usuario involucrado que ha sido eliminado o los permisos de acceso revocados por otro usuario.',
    ErrorFileSizeLimit: 'No se pudo completar la carga del archivo {0}, porque no puede cargar un archivo de más de ∼ {1} GB',
    ErrorUploadExceededText: 'No se pudo completar la carga del archivo {0} porque su cuenta se ha quedado sin espacio.',
    ErrorUploadText: 'La carga del archivo {0} se encontró con un error desconocido y no se pudo completar. Por favor, repita el proceso de carga.',
    ErrorUploadTitle: 'Error al cargar el archivo.',
    exported: 'Exportado',
    exporting: 'Exportando',
    failed: 'Fallado',
    help: 'Ayuda',
    HourAbbreviation: 'h',
    HourPluralFormat: '1#hora#horas',
    HourPluralFormatTemplate: '1#{0} hora#{0} horas',
    HyperLinkTooltip: 'CTRL+Click para seguir el enlace',
    items_selected_plural: '1#{0} artículo seleccionado#{0} artículos seleccionados',
    madeBy: 'Desarrollado por',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'y {0} más',
    next: 'Siguiente',
    no_items_selected: 'No hay artículos seleccionados',
    None_Text: 'Nada',
    Not_set: 'No configurado',
    Ok: 'OK',
    open_details_new_tab: 'Abrir detalles en una nueva pestaña',
    OpeningWindow: 'Apertura...',
    OpenOriginal: 'Abrir original',
    OperationError_Title: 'La operación no se pudo completar',
    parentActivity: 'actividad de los padres',
    Remove: 'Quitar',
    Reset: 'Restablecer',
    Save: 'Guardar',
    saved: 'Guardado',
    saving: 'Guardando',
    Search: 'Buscar',
    setCompleted: 'Establecer como Completado',
    space_exceeded_description: 'No hay suficiente espacio de almacenamiento disponible para almacenar archivos.',
    space_exceeded_title: 'El almacenamiento está lleno',
    summary: 'Resumen',
    timer_text: '1#{0}segundo#{0}segundos',
    title_notFullyCompleted: 'La operación no se pudo completar parcial o totalmente',
    title_reload: 'Por favor, vuelva a cargar la página',
    total: 'Total',
    turn_off: 'Apagar',
    type: 'Tipo',
    Type_for_search: 'Escriba para buscar',
    Type_for_search_or_add: 'Escriba para buscar o agregar ',
    upload: 'Subir',
    WebPushNotificationPanelLink: 'habilita las notificaciones de escritorio.',
    WebPushNotificationPanelText: '{brandName} necesita su permiso para ',
    you_user_text: 'usted',
};
